<template>
    <div
        :class="{'styled-checkbox': true, [wrapperClassName]: !!wrapperClassName}"
        @click="toggleCheck"
    >
        <input
            :id="id"
            :name="name"
            type="checkbox"
            class="styled-checkbox__input"
            v-model="value"
        >
        <label
            :for="id"
            class="styled-checkbox__label"
            @click.prevent
        >
            <span v-show="isChecked">
                <slot name="checked-icon">
                    ✔
                </slot>
            </span>
            <span v-show="!isChecked">
                <slot name="unchecked-icon"></slot>
            </span>
        </label>
    </div>
</template>

<script>
export default {
    name: 'styled-checkbox',
    props: {
        wrapperClassName: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        id: {
            type: String,
            required: true,
        },
        value: {
            required: true
        },
        checked: {
            type: [String, Number, Object, Array, Boolean],
            default: null
        },
    },

    computed: {
        isChecked() {
            return this.checked ? true : false
        }
    },

    methods: {
        emitValueUpdate() {
            this.$emit('change', this.isChecked);
        },
        toggleCheck() {
            this.emitValueUpdate();
        },
    },
}
</script>

<style lang="scss" scoped>
.styled-checkbox {
    @apply inline-flex relative;

    &__label {
        @apply absolute select-none inset-0 cursor-pointer;
    }

    &__input {
        @apply hidden;
    }
}
</style>
